module.exports = __webpack_public_path__ + "static/media/Palazzo Reale - DK Grey - Peri_White.65ae6275.jpg";